<template>
    <icon-label
        :size="size"
        :show-icon="showIcon"
        :show-label="showLabel"
        :icon="icon"
        :label="label" />
</template>

<script setup>
import IconLabel from '@/common/icon-label/icon-label.vue';

import { getComputedColor } from '@/utils/color.js';
import capitalize from 'lodash/capitalize';
import { computed } from 'vue';

import { FEEDBACK_TYPES } from '@/voc/constants/feedback.js';

const { type } = defineProps({
    type: {
        type: String,
        default: '',
    },
    showIcon: {
        type: Boolean,
        default: true,
    },
    showLabel: {
        type: Boolean,
        default: true,
    },
    size: {
        type: String,
        default: 'large',
    },
});

const label = computed(() => FEEDBACK_TYPES[type?.toLowerCase()]?.label || capitalize(type?.toLowerCase()));
const icon = computed(() => ({
    type: FEEDBACK_TYPES[type?.toLowerCase()]?.icon,
    color: getComputedColor('--palette-gray-110'),
    borderColor: getComputedColor(FEEDBACK_TYPES[type?.toLowerCase()]?.borderColor || '--palette-gray-110'),
    backgroundColor: `rgba(${getComputedColor(FEEDBACK_TYPES[type?.toLowerCase()]?.bgColor || '--palette-gray-0')}, 0.4)`,
}));
</script>
